import type { DashboardPanelSpec, DashboardTarget } from '@/features/statistics/api';

/**
 * Fixed panel presets per page — the user builds nothing themselves (the
 * panel builder does not come back); a page just asks for its preset and
 * passes it to `StatsGrid`. Per *Statistiek-elementen*: an department page
 * shows sleep, movement, heart rate and sessions.
 */
export function departmentStatsPreset(target: DashboardTarget): DashboardPanelSpec[] {
  return [
    {
      id: 'sleep',
      type: 'series',
      target,
      grain: 'day',
      range: 'last_30_days',
      metrics: ['sleep_duration'],
    },
    {
      id: 'movement',
      type: 'series',
      target,
      grain: 'day',
      range: 'last_30_days',
      metrics: ['steps'],
    },
    {
      id: 'heart-rate',
      type: 'series',
      target,
      grain: 'day',
      range: 'last_30_days',
      metrics: ['heart_rate'],
    },
    {
      id: 'sessions',
      type: 'sessions',
      target,
      range: 'last_30_days',
      limit: 20,
    },
  ];
}
